import { murnAddressToFormkit, murnAddressFromFormkit } from "@modernary/mui/components/fk";
import type { Organization } from "@/views/organization/organization";
import { fillPrefixedAddressLookupValues } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: Organization) {
  entity._authRequestFields = ["id"] as (keyof Organization)[];
  return entity;
}
function getInitialData() {
  const result = {} as Organization; //TODO:TS
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Organization }) {
  addAuthRequestFields(response.data);
  await fillPrefixedAddressLookupValues(response.data, ["mail"]);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Organization }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter() {}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Organization) {
  murnAddressToFormkit(data, "mail");
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {
  //TODO:TS
  murnAddressFromFormkit(data as Organization, "mail");
}
